/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { TestRouter, TestRouterInterface } from "../TestRouter";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]",
      },
    ],
    name: "getAmountsOut",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
    ],
    name: "swapExactETHForTokensSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
    ],
    name: "swapExactTokensForETHSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
    ],
    name: "swapExactTokensForTokensSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class TestRouter__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<TestRouter> {
    return super.deploy(overrides || {}) as Promise<TestRouter>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): TestRouter {
    return super.attach(address) as TestRouter;
  }
  connect(signer: Signer): TestRouter__factory {
    return super.connect(signer) as TestRouter__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TestRouterInterface {
    return new utils.Interface(_abi) as TestRouterInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TestRouter {
    return new Contract(address, _abi, signerOrProvider) as TestRouter;
  }
}
